<accordion>
  <accordion-group heading="Content 1">
    <p>accordion 1</p>
  </accordion-group>
  <accordion-group heading="Initially expanded"
                   [isOpen]="isFirstOpen">
    This content is straight in the template.
  </accordion-group>
  <accordion-group heading="Content 2">
    <p>accordion 3</p>
  </accordion-group>
</accordion>
